import Vue from 'vue';
import { spacings } from '../Token/token';
import { appendPx } from '../Token/helper/tokenHelper';

const validateSpacings = (s: string) => Object.keys(spacings).includes(s);

/**
 * Spacer Component
 * @displayName Spacer (Margin) | Padder (Padding)
 */
const createSpacings = (type: 'margin' | 'padding') =>
  Vue.extend({
    name: type === 'padding' ? 'Padder' : 'Spacer',
    inheritAttrs: false,
    props: {
      /**
       * Represent right & left if horizontal is present, any right or left props passed will be ignored
       * `xs`, `sm`, `md`, `lg`, `xl`, `xxl`, `xxxl`
       */
      horizontal: {
        type: String,
        validator: validateSpacings,
      },
      /**
       * Represent top & bottom if horizontal is present, any top or bottom props passed will be ignored
       * `xs`, `sm`, `md`, `lg`, `xl`, `xxl`, `xxxl`
       */
      vertical: {
        type: String,
        validator: validateSpacings,
      },
      /**
       * Represents spacing for top side
       * `xs`, `sm`, `md`, `lg`, `xl`, `xxl`, `xxxl`
       */
      top: {
        type: String,
        validator: validateSpacings,
      },
      /**
       * Represents spacing for right side
       * `xs`, `sm`, `md`, `lg`, `xl`, `xxl`, `xxxl`
       */
      right: {
        type: String,
        validator: validateSpacings,
      },
      /**
       * Represents spacing for bottom side
       * `xs`, `sm`, `md`, `lg`, `xl`, `xxl`, `xxxl`
       */
      bottom: {
        type: String,
        validator: validateSpacings,
      },
      /**
       * Represents spacing for left side
       * `xs`, `sm`, `md`, `lg`, `xl`, `xxl`, `xxxl`
       */
      left: {
        type: String,
        validator: validateSpacings,
      },
    },
    render(h, ctx) {
      const getSpacings = () => {
        const { top, right, bottom, left, horizontal, vertical } = this;

        if (horizontal && vertical) {
          return {
            [`${type}Top`]: appendPx(spacings[vertical]),
            [`${type}Right`]: appendPx(spacings[horizontal]),
            [`${type}Bottom`]: appendPx(spacings[vertical]),
            [`${type}Left`]: appendPx(spacings[horizontal]),
          };
        }

        if (horizontal) {
          return {
            [`${type}Left`]: appendPx(spacings[horizontal]),
            [`${type}Right`]: appendPx(spacings[horizontal]),
            [`${type}Top`]: appendPx(spacings[top] || 0),
            [`${type}Bottom`]: appendPx(spacings[bottom] || 0),
          };
        }

        if (vertical) {
          return {
            [`${type}Top`]: appendPx(spacings[vertical]),
            [`${type}Right`]: appendPx(spacings[right] || 0),
            [`${type}Bottom`]: appendPx(spacings[vertical]),
            [`${type}Left`]: appendPx(spacings[left] || 0),
          };
        }

        return {
          [`${type}Top`]: appendPx(spacings[top] || 0),
          [`${type}Right`]: appendPx(spacings[right] || 0),
          [`${type}Bottom`]: appendPx(spacings[bottom] || 0),
          [`${type}Left`]: appendPx(spacings[left] || 0),
        };
      };
      return h(
        'div',
        {
          style: getSpacings(),
          attrs: this.$attrs,
        },
        this.$slots.default
      );
    },
  });

export const Padder = createSpacings('padding');
export const Spacer = createSpacings('margin');
